module.exports = __webpack_public_path__ + "img/shape-metal_ac@2x.532870b0.png";